/**
 * @module use-cases/catalog/actions
 * @desc Catalog Action Creators
 *
 */

import { ResellerAvailableCatalogsResponse } from 'core/services/bff';
import { createAction, createAsyncAction } from 'core/use-cases/utilities';

import type { Catalog } from 'core/domains';

type QueryOptions = Catalog['queryOptions'];

export const catalogCleanUp = createAction<'catalogCleanUp', undefined>('catalogCleanUp');

export const searchEnter = createAction<'searchEnter', string>('searchEnter');

export const searchEnterRedirect = createAction<'searchEnterRedirect', undefined>(
  'searchEnterRedirect',
);

export const catalogFetch = createAsyncAction<'catalogFetch', QueryOptions, Catalog>(
  'catalogFetch',
);

export const searchPreviousFetch = createAsyncAction<'searchPreviousFetch', QueryOptions, Catalog>(
  'searchPreviousFetch',
);

export const catalogNextPageFetch = createAsyncAction<
  'catalogNextPageFetch',
  QueryOptions,
  Catalog
>('catalogNextPageFetch');

export const getResellerAvailableCatalogs = createAsyncAction<
  'getResellerAvailableCatalogs',
  undefined,
  ResellerAvailableCatalogsResponse
>('getResellerAvailableCatalogs');
